import { MenuContainer, MenuItem, Container } from "./style";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Api from "../../../../adapters/api/api";
import { ProviderTable } from "./Components/ProviderTable";
import { UpdateProvider } from "./Components/UpdateProvider";
import { ProviderActions } from "./Components/ProviderActions";
import { IServiceProviderProfile } from "../../../../interfaces/entities/IServiceProviderProfile";

export const UserInfo: React.FC = () => {
  const { profile_id } = useParams();

  const [profile, setProfile] = useState<IServiceProviderProfile | null>(null);
  const [option, setOption] = useState(0);

  useEffect(() => {
    if (profile_id) {
      getProfileInfo(profile_id);
    }
  }, [profile_id]);

  const getProfileInfo = async (profile_id: string) => {
    try {
      const profileReponse = await Api.get(
        `/admin/user/profile?profile_id=${profile_id}`
      );
      setProfile(profileReponse.data);
    } catch (err) {
      console.log(err);
    }
  };

  const renderOption = () => {
    if (!profile) {
      return null;
    }
    if (option === 0) return <ProviderTable profile={profile} />;
    if (option === 1) return <UpdateProvider profile={profile} />;
    if (option === 2) return <ProviderActions profile={profile} />;
    return null;
  };

  return (
    <>
      <Container>
        <div>
          <MenuContainer>
            <MenuItem onClick={() => setOption(0)} isSelected={option === 0}>
              Perfil
            </MenuItem>
            <MenuItem onClick={() => setOption(1)} isSelected={option === 1}>
              Edições
            </MenuItem>
            <MenuItem onClick={() => setOption(2)} isSelected={option === 2}>
              Ações
            </MenuItem>
          </MenuContainer>
          {renderOption()}
        </div>
      </Container>
    </>
  );
};
